import styled, { css } from 'styled-components';
import { theme } from './theme';
import media from './mediaQueries';
import { rgba } from 'polished';

// TODO: When application is reconfigured to work with the backend, then delete borders

const StyledPageContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-width: 1162px;
  margin: 0 auto;
  //border: 3px solid green;
  ${media.mobile`
    flex-direction: column;
  `}
  ${media.desktop`
    padding: 0 26px;
  `}
`;

const StyledPageSidebar = styled.aside`
  width: 100%;
  max-width: 215px;
  margin-right: 20px;
  //border: 3px solid pink;
  ${media.mobile`
    display: none;
    visibility: hidden;
  `}
  ${media.desktop`
    position: sticky;
    top: 81px;
    padding-top: 3px;
    align-self: baseline;
  `}
`;

const StyledPageContent = styled.div`
  display: flex;
  width: 100%;
  max-width: 910px;
  //border: 2px solid pink;

  ${media.mobile`
    margin: 0 auto;
    flex-direction: ${props => (props.reverse ? 'column-reverse' : 'column')};
    ${props =>
      props.lighterBg &&
      css`
        background-color: #121212;
      `}
  `}
  ${media.desktop`
    flex-direction: row-reverse;
  `}
`;

const StyledPageMainContent = styled.div`
  width: 100%;
  //border: 3px solid blue;
`;

const StyledPageMainSidebar = styled.div`
  width: 100%;
  //border: 3px solid blue;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${rgba(theme.color.gray, 0.5)};
    border-radius: 30px;
  }

  ${media.mobile`
    max-width: 100%;
  `}
  ${media.desktop`
    position: sticky;
    top: 84px;
    align-self: baseline;
    min-width: 220px;
    max-width: 300px;
    max-height: calc(100vh - 85px);
    margin-left: 20px;
    overflow-y: auto;
  `}
`;

const StyledDividedPageContent = styled.div`
  width: 100%;
  ${media.desktop`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  `}
`;

export {
  StyledPageContainer,
  StyledPageSidebar,
  StyledPageContent,
  StyledPageMainSidebar,
  StyledPageMainContent,
  StyledDividedPageContent,
};
